'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DescriptionController = function DescriptionController(growl, ModelFactory, Resource, $state, $uibModal, Util) {
  'ngInject';

  (0, _classCallCheck3.default)(this, DescriptionController);
  var vm = this;
  vm.form = {};
  vm.summernoteOptions = Util.getSummernoteOptions();
  vm.htmlDescription = "";
  vm.save = save;
  vm.$onInit = init;
  vm.formSubmitted = false;
  vm.remove = remove;

  function init() {
    vm.modelName = vm.model; // preso dal parent
    vm.modelStructure = _lodash2.default.result(ModelFactory, 'get' + _lodash2.default.upperFirst(vm.modelName) + 'Structure');

    console.log("Lang:", vm.language);
    /*Invoke e.g ModelFactory.getNatureStructure()*/
  }

  function save(itemStrings) {

    if (vm.form[vm.language].$invalid) {
      vm.formSubmitted = true;
      angular.forEach(vm.form[vm.language].$error, function (value, key) {
        if (key === 'numeric-array') {
          growl.error('Il geojeson inserito non è valido');
        } else if (key === 'required') {
          growl.error('Compilare tutti i campi obbligatori');
        }
      });
      return;
    }

    var itemToSave = {};
    itemToSave[vm.modelName] = _lodash2.default.get(vm.item, vm.modelName);

    // Se non c'è l'id, la risorsa è nuova da inserire
    if (_lodash2.default.isNil(itemToSave[vm.modelName].id)) {

      itemToSave[vm.modelName].active = true;
      itemToSave[vm.modelName + 'StringsList'] = _lodash2.default.get(vm.item, vm.modelName + 'StringsList');
      itemToSave.geoPoints = [];
      /* Example: Resource.post('flora', vm.item.flora) */
      Resource.post(vm.modelName, itemToSave).then(function (res) {
        console.log('Risorsa salvata!', res);
        vm.item = res.data;
        if (vm.modelName === 'itinerary') {
          var model = _lodash2.default.get(itemToSave, vm.model);
          var geojson = JSON.parse(model.geojson);
          saveGeoPoints(geojson[0]).then(function (e) {
            growl.success('Risorsa creata con successo!');
            $state.go('dashboard.detail.description', {
              id: res.data[vm.modelName].id,
              modelName: vm.modelName
            });
          });
        } else {
          growl.success('Risorsa creata con successo!');
          $state.go('dashboard.detail.description', {
            id: res.data[vm.modelName].id,
            modelName: vm.modelName
          });
        }
      }, function (err) {
        growl.error('Errore nella creazione della risorsa');
      });
    } else {
      /* Example: Resource.put('flora', vm.item.flora) */
      itemToSave.geoPoints = _lodash2.default.get(vm.item, 'geoPoints');
      Resource.put(vm.modelName, itemToSave).then(function (res) {
        console.log('Risorsa salvata!', res);

        Resource.putStrings(vm.modelName, itemStrings).then(function (res) {
          console.log('Stringhe modificate per', itemStrings, 'risposta:', res);
          growl.success('Modifica salvata con successo');

          if (vm.modelName === 'itinerary') {
            var model = _lodash2.default.get(itemToSave, vm.model);
            var geojson = JSON.parse(model.geojson);
            saveGeoPoints(geojson[0]);
          }
        });
      });
    }
  }

  /**
   * Save geo points
   */
  function saveGeoPoints(latLngArray) {

    var itemToSave = {};
    itemToSave[vm.model] = _lodash2.default.get(vm.item, vm.model);
    itemToSave.geoPoints = [];
    var geoPoint = {
      latitude: latLngArray[1],
      longitude: latLngArray[0]
    };
    itemToSave.geoPoints.push(geoPoint);
    return Resource.putGeoPoints(vm.model, itemToSave).then(function (res) {}, function (err) {
      growl.error('Errore nel salvataggio delle coordinate geografiche');
    });
  }

  function remove() {
    $uibModal.open({
      component: 'confirmDialog',
      windowClass: 'modal-mini modal-primary',
      resolve: {
        message: function message() {
          return 'Confermi di voler cancellare questa risorsa?';
        }
      }
    }).result.then(function () {
      Resource.remove(vm.modelName, _lodash2.default.get(vm.item, vm.modelName + '.id')).then(function (res) {
        growl.success('Risorsa cancellata con successo!');

        $state.go('dashboard.list', {
          modelEnum: vm.modelName.toUpperCase()
        });
      });
    });
  }
};

exports.default = DescriptionController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/description/description.controller.js